const colorchange = (swap) => {

    // b.classList.remove('theme-yellow');
    // b.classList.add('theme-black');
    // h.classList.remove('theme-yellow');
    // h.classList.add('theme-black');
}

function colorswap() {

    let csTest = document.querySelector('[js-hook-swapcolor]');
	let cst = document.querySelectorAll('[js-hook-swapcolor]');
    let b = document.body;
    let h = document.documentElement;

	let baseTheme = null;
	if (b.classList.contains('theme-2027')) {
		baseTheme = 'theme-2027';
	} else if (b.classList.contains('theme-2025')) {
		baseTheme = 'theme-2025';
	}

    if (csTest !== null){
        if(b.classList.contains('general')) {
			const resetToBaseTheme = () => {
				b.classList.remove('theme-yellow');
				b.classList.remove('theme-darkblue');
				b.classList.remove('theme-2025');
				b.classList.remove('theme-2027');
				if (baseTheme !== null) {
					b.classList.add(baseTheme);
				}
				h.classList.remove('theme-yellow');
				h.classList.remove('theme-darkblue');
				h.classList.remove('theme-2025');
				h.classList.remove('theme-2027');
				if (baseTheme !== null) {
					h.classList.add(baseTheme);
				}
			};

			const setTheme = (theme) => {
				b.classList.remove('theme-yellow');
				b.classList.remove('theme-darkblue');
				b.classList.remove('theme-2025');
				b.classList.remove('theme-2027');
				b.classList.add(theme);
				h.classList.remove('theme-yellow');
				h.classList.remove('theme-darkblue');
				h.classList.remove('theme-2025');
				h.classList.remove('theme-2027');
				h.classList.add(theme);
			};

			const updateGeneralTheme = () => {
				if (cst.length >= 3) {
					if (!cst[2].classList.contains('is--out-view')) {
						setTheme('theme-darkblue');
						return;
					}
					if (!cst[1].classList.contains('is--out-view')) {
						setTheme('theme-yellow');
						return;
					}
					if (!cst[0].classList.contains('is--out-view')) {
						setTheme('theme-2025');
						return;
					}
					resetToBaseTheme();
					return;
				}

				if (cst.length >= 2) {
					if (cst[0].classList.contains('is--out-view') && cst[1].classList.contains('is--out-view')) {
						resetToBaseTheme();
					} else if (cst[1].classList.contains('is--out-view')) {
						setTheme('theme-darkblue');
					} else if (cst[0].classList.contains('is--out-view')) {
						setTheme('theme-yellow');
					}
					return;
				}
			};

			updateGeneralTheme();

            var observer = new MutationObserver(function () {
				updateGeneralTheme();
            })
			cst.forEach((trigger) => {
				observer.observe(trigger, {
					attributes: true,
					attributeFilter: ['class'],
					childList: true,
					characterData: false
				})
			});
            
        } else if (b.classList.contains('theme-darkred')) {
            cst.forEach((cstrigger) => {

            if(!cstrigger.classList.contains('is--out-view')){
                if (b.classList.contains('theme-yellow')) {
                    b.classList.add('theme-darkred');
                    b.classList.remove('theme-yellow');
                    h.classList.add('theme-darkred');
                    h.classList.remove('theme-yellow');
                }
            }
            var observer = new MutationObserver(function () {
                if (cstrigger.classList.contains('is--out-view')) {
                    b.classList.remove('theme-yellow');
                    b.classList.add('theme-darkred');
                    h.classList.remove('theme-yellow');
                    h.classList.add('theme-darkred');
                } else {
                    if (b.classList.contains('theme-darkred')) {
                        b.classList.add('theme-yellow');
                        b.classList.remove('theme-darkred');
                        h.classList.add('theme-yellow');
                        h.classList.remove('theme-darkred');
                    }
                }
            })
            observer.observe(cstrigger, {
                attributes: true,
                attributeFilter: ['class'],
                childList: false,
                characterData: false
            })
        })
        } else if (b.classList.contains('theme-darkyellow')) {
            cst.forEach((cstrigger) => {

            if(!cstrigger.classList.contains('is--out-view')){
                if (b.classList.contains('theme-red')) {
                    b.classList.add('theme-darkyellow');
                    b.classList.remove('theme-red');
                    h.classList.add('theme-darkyellow');
                    h.classList.remove('theme-red');
                }
            }
            var observer = new MutationObserver(function () {
                if (cstrigger.classList.contains('is--out-view')) {
                    b.classList.remove('theme-red');
                    b.classList.add('theme-darkyellow');
                    h.classList.remove('theme-red');
                    h.classList.add('theme-darkyellow');
                } else {
                    if (b.classList.contains('theme-darkyellow')) {
                        b.classList.add('theme-red');
                        b.classList.remove('theme-darkyellow');
                        h.classList.add('theme-red');
                        h.classList.remove('theme-darkyellow');
                    }
                }
            })
            observer.observe(cstrigger, {
                attributes: true,
                attributeFilter: ['class'],
                childList: false,
                characterData: false
            })
        })
		} else if (b.classList.contains('dark')) {

			cst.forEach((cstrigger) => {

				if(!cstrigger.classList.contains('is--out-view')){
					// if (b.classList.contains('theme-red')) {
					// 	b.classList.add('theme-darkyellow');
					// 	b.classList.remove('theme-red');
					// 	h.classList.add('theme-darkyellow');
					// 	h.classList.remove('theme-red');
					// }
				}
				var observer = new MutationObserver(function () {
					if (cstrigger.classList.contains('is--out-view')) {
						b.classList.remove('theme-darkblue');
						b.classList.remove('theme-2025');
						b.classList.remove('theme-2027');
						if (baseTheme !== null) {
							b.classList.add(baseTheme);
						}
						h.classList.remove('theme-darkblue');
						h.classList.remove('theme-2025');
						h.classList.remove('theme-2027');
						if (baseTheme !== null) {
							h.classList.add(baseTheme);
						}
					} else {
						if (b.classList.contains('theme-2025') || b.classList.contains('theme-2027')) {
							b.classList.add('theme-darkblue');
							b.classList.remove('theme-2025');
							b.classList.remove('theme-2027');
							h.classList.add('theme-darkblue');
							h.classList.remove('theme-2025');
							h.classList.remove('theme-2027');
						}
					}
				})
				observer.observe(cstrigger, {
					attributes: true,
					attributeFilter: ['class'],
					childList: false,
					characterData: false
				})
			});

		} else if (b.classList.contains('locations')) {

			cst.forEach((cstrigger) => {

				if(!cstrigger.classList.contains('is--out-view')){
					// if (b.classList.contains('theme-red')) {
					// 	b.classList.add('theme-darkyellow');
					// 	b.classList.remove('theme-red');
					// 	h.classList.add('theme-darkyellow');
					// 	h.classList.remove('theme-red');
					// }
				}
				var observer = new MutationObserver(function () {
					if (cstrigger.classList.contains('is--out-view')) {
						b.classList.remove('theme-darkblue');
						b.classList.remove('theme-2025');
						b.classList.remove('theme-2027');
						if (baseTheme !== null) {
							b.classList.add(baseTheme);
						}
						h.classList.remove('theme-darkblue');
						h.classList.remove('theme-2025');
						h.classList.remove('theme-2027');
						if (baseTheme !== null) {
							h.classList.add(baseTheme);
						}
					} else {
						if (b.classList.contains('theme-2025') || b.classList.contains('theme-2027')) {
							b.classList.add('theme-darkblue');
							b.classList.remove('theme-2025');
							b.classList.remove('theme-2027');
							h.classList.add('theme-darkblue');
							h.classList.remove('theme-2025');
							h.classList.remove('theme-2027');
						}
					}
				})
				observer.observe(cstrigger, {
					attributes: true,
					attributeFilter: ['class'],
					childList: false,
					characterData: false
				})
			});

        } else {
            cst.forEach((cstrigger) => {
                if(!cstrigger.classList.contains('is--out-view')){
                    if (b.classList.contains('theme-darkblue')) {
                        b.classList.add('theme-yellow');
                        b.classList.remove('theme-darkblue');
                        h.classList.add('theme-yellow');
                        h.classList.remove('theme-darkblue');
                    }
                }
                var observer = new MutationObserver(function () {
                    if (cstrigger.classList.contains('is--out-view')) {
                        b.classList.remove('theme-darkblue');
                        b.classList.add('theme-yellow');
                        h.classList.remove('theme-darkblue');
                        h.classList.add('theme-yellow');
                    } else {
                        if (b.classList.contains('theme-yellow')) {
                            b.classList.add('theme-darkblue');
                            b.classList.remove('theme-yellow');
                            h.classList.add('theme-darkblue');
                            h.classList.remove('theme-yellow');
                        }
                    }
                })
                observer.observe(cstrigger, {
                    attributes: true,
                    attributeFilter: ['class'],
                    childList: false,
                    characterData: false
                })
            });
        }
	}
}

export default colorswap;



// function colorswap() {

// 	let cstrigger = document.querySelector('[js-hook-swapcolor]');
//     let b = document.body;

// 	if (cstrigger !== null){


//         if(!cstrigger.classList.contains('is--out-view')){
//             if (b.classList.contains('theme-yellow')) {
//                 b.classList.add('theme-darkblue');
//                 b.classList.remove('theme-yellow');
//             }
//         }

// 		var observer = new MutationObserver(function () {
// 			if (cstrigger.classList.contains('is--out-view')) {
// 				b.classList.remove('theme-darkblue');
// 				b.classList.add('theme-yellow');
// 			} else {
// 				if (b.classList.contains('theme-yellow')) {
// 					b.classList.add('theme-darkblue');
// 					b.classList.remove('theme-yellow');
// 				}
// 			}
// 		})

// 		observer.observe(cstrigger, {
// 			attributes: true,
// 			attributeFilter: ['class'],
// 			childList: false,
// 			characterData: false
// 		})
// 	}
// }

// export default colorswap;



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/utilities/colorswap.js